import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        <div className="gradient-overlay"></div>
        <div className="animated-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Finally see what's <span className="gradient-text">actually happening</span> in your salon.
            </h1>
            <p className="hero-subtitle">
              Jajoga connects bookings, calls, payments, and operations into clear insight — so salon owners can grow without guessing.
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary-hero" onClick={scrollToContact}>
                Show Me Where I'm Losing Money
              </button>
              <button className="btn btn-secondary-hero" onClick={() => {
                const element = document.getElementById('how-it-works');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}>
                Explore How It Works
              </button>
            </div>
            <p className="hero-micro-text">Built for modern salon and medspa operators</p>
          </div>

{/* Hero image is now CSS background */}
        </div>

        <div className="social-proof">
          <p className="social-proof-text">Works with your existing booking system • See patterns in your first week • No technical setup</p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
